<template>
	<div class="form__group">
		<multiselect :options="options" :placeholder="placeholder" :allow-empty="allowEmpty" label="label" track-by="id"
		             :searchable="false" :multiple="multiple" :show-labels="false" v-model="selected"
		             :class="{ 'form__control': true, 'form__control--invalid': errors.first(this.name) }">>
		</multiselect>

		<label class="form__label">Select category</label>
		<div class="form__validation">{{ errors.first(this.name) }}</div>
	</div>
</template>

<script>
	import Select from './Select';

	export default {
		name: 'FormControlCategory',
		mixins: [Select],
		data() {
			return {
				options: [
					{
						label: 'Conference Insight',
						id: 1,
					},
					{
						label: 'Sector Insight',
						id: 2,
					},
					{
						label: 'Marketing Material',
						id: 3,
					},
				],
			}
		},
	}
</script>

